import { hillo } from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import VoucherTypes from '@/model/dataLayer/api/Vip/VoucherTypes'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import dayjs from 'dayjs'

const voucherCode = 'membership/voucher/voucher-codes'

const entity = {
  code: {},
  usageCount: {},
  maxUsageCount: {},
  expiredAt: {
    type: IKDataEntity.Types.Date
  },
  // expiredAtDate: {
  //   type: IKDataEntity.Types.Date,
  //   formConfig: {
  //     require: false
  //   },
  //   header: false
  // },
  // expiredAtTime: {
  //   type: IKDataEntity.Types.Time,
  //   formConfig: {
  //     require: false
  //   },
  //   header: false
  // },
  voucherTypeId: {
    formConfig: {
      type: {
        selectItems: VoucherTypes.forceGetList
      }
    },
    header: false
  },
  active: {
    type: IKDataEntity.Types.Boolean,
    formConfig: {
      default: true
    }
  },
  maxExchangePerUser: {}
}
const config = {
  load: async function (filter) {
    const voucherTypeId = filter[0].voucherTypeId
    const res = (await hillo.get(cloudV2Url + voucherCode + '/voucher-type/' + voucherTypeId)).map(it => {
      it.voucherTypeId = voucherTypeId
      it.expiredAt = dayjs(it.expiredAt).format('YYYY-MM-DD')
      // const [expiredAtDate, expiredAtTime] = it.expiredAt.split('T')
      // it.expiredAt = expiredAtDate + ' ' + expiredAtTime
      // it.expiredAtDate = expiredAtDate
      // it.expiredAtTime = expiredAtTime
      return it
    })
    return res
  },
  add: async function (item) {
    item.expiredAt = item.expiredAt + 'T00:00:00'
    // item.expiredAt = item.expiredAtDate + 'T' + item.expiredAtTime
    return (await hillo.jsonPost(cloudV2Url + voucherCode + '/' + item.voucherTypeId + '/batch', {
      ...item
    }))
  },
  edit: async function (item) {
    item.expiredAt = item.expiredAt + 'T00:00:00'
    // item.expiredAt = item.expiredAtDate + 'T' + item.expiredAtTime
    return (await hillo.jsonPost(cloudV2Url + voucherCode + '/' + item.voucherTypeId, {
      ...item
    }))
  },
  remove: async function (id) {
    return (await hillo.jsonPost(cloudV2Url + voucherCode + '/' + id + '/delete', {
    }))
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export async function getVoucherCode (voucherTypeId) {
  return (await hillo.get(cloudV2Url + voucherCode + '/voucher-type/' + voucherTypeId))
}

export async function saveVoucherCodeByTypeId (voucherTypeId, item) {
  return (await hillo.jsonPost(cloudV2Url + voucherCode + voucherTypeId, {
    ...item
  }))
}
